import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CustomDashboardsService} from "app/modules/my-limegear/services/my-limegear.service";
import {PipelineLoanCharacteristicsService} from "app/modules/pipeline/services/pipeline-loan-characteristics.service";
import {NoDataActionType} from "app/modules/shared/interfaces/no-data";
import {ICardInfo} from "app/modules/my-limegear/components/standalone-components/interfaces/stanalone-components.data";

@Component({
    selector: 'loan-character-occupan-type-smdc',
    templateUrl: './loan-character-occupan-type-smdc.component.html',
    styleUrls: ['./loan-character-occupan-type-smdc.component.scss']
})
export class LoanCharacterOccupanTypeSmdcComponent implements OnInit, AfterViewInit {

    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _loanCharateridticsService: PipelineLoanCharacteristicsService
    ) {
    }

    action: NoDataActionType;
    chartCardInfo: ICardInfo;
    cardDrilldownUrl = '/reporting/pipeline';

    ngOnInit() {
        this.action = NoDataActionType.pageStart;
        this.chartCardInfo = {
            name: 'Occupancy Type',
            urlSegment: 'insights_pipelineLoanCharacteristics',
            cardId: 'loan-character-occupan-type',
            module: 'Pipeline',
        };

        this._loanCharateridticsService.initializeLargeCard(
            this.chartCardInfo,
            this.action,
            this.cardDrilldownUrl
        );
    }

    ngAfterViewInit() {
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this._loanCharateridticsService.getLoanCharacteristics(
                this.chartCardInfo,
                changes.displayOptions,
                changes.hierarchyfilters,
                changes.action,
                '',
                'occupancyType'
            );
        });
    }
}
